// src/router/ocorrencias.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional', 'coordenadores', 'diretoria']

const ocorrenciasBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Ocorrências',
        to: 'Ocorrencias'
    }
]

export default [
    {
        path: '/ocorrencias',
        name: 'Ocorrencias',
        component: () => import('@/views/Ocorrencias/OcorrenciaListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Ocorrências',
            breadcrumb: ocorrenciasBreadCrumb
        },
    },
    {
        path: '/ocorrencias/novo',
        name: 'OcorrenciaNova',
        component: () => import('@/views/Ocorrencias/NovaOcorrenciaPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Nova Ocorrência',
            breadcrumb: [
                ...ocorrenciasBreadCrumb,
                {
                    label: 'Nova Ocorrencia',
                    to: 'OcorrenciaNova'
                }
            ]
        }
    },
    {
        path: '/ocorrencias/:id/detalhe',
        name: 'OcorrenciaDetalhes',
        component: () => import('@/views/Ocorrencias/NovaOcorrenciaPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes da Ocorrência',
            breadcrumb: [
                ...ocorrenciasBreadCrumb,
                {
                    label: 'Detalhes',
                    to: 'OcorrenciaNova'
                }
            ]
        }
    },
];
